import { codePointSize as S, codePointAt as C, EditorSelection as x, CharCategory as X, Prec as de, Facet as me, combineConfig as De, StateField as Z, StateEffect as O, MapMode as Y, RangeValue as Le, RangeSet as oe, fromCodePoint as ge, Text as Me, Annotation as Be } from "./ghl-ui.es268.js";
import { EditorView as F, keymap as be, Direction as ke, showTooltip as Fe, getTooltip as ye, ViewPlugin as je, logException as G, Decoration as W, WidgetType as $e } from "./ghl-ui.es269.js";
import { syntaxTree as V, indentUnit as Ue } from "./ghl-ui.es424.js";
class xe {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(e, t, i) {
    this.state = e, this.pos = t, this.explicit = i, this.abortListeners = [];
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(e) {
    let t = V(this.state).resolveInner(this.pos, -1);
    for (; t && e.indexOf(t.name) < 0; )
      t = t.parent;
    return t ? {
      from: t.from,
      to: this.pos,
      text: this.state.sliceDoc(t.from, this.pos),
      type: t.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(e) {
    let t = this.state.doc.lineAt(this.pos), i = Math.max(t.from, this.pos - 250), o = t.text.slice(i - t.from, this.pos - t.from), s = o.search(we(e, !1));
    return s < 0 ? null : { from: i + s, to: this.pos, text: o.slice(s) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  */
  addEventListener(e, t) {
    e == "abort" && this.abortListeners && this.abortListeners.push(t);
  }
}
function se(n) {
  let e = Object.keys(n).join(""), t = /\w/.test(e);
  return t && (e = e.replace(/\w/g, "")), `[${t ? "\\w" : ""}${e.replace(/[^\w\s]/g, "\\$&")}]`;
}
function Ne(n) {
  let e = /* @__PURE__ */ Object.create(null), t = /* @__PURE__ */ Object.create(null);
  for (let { label: o } of n) {
    e[o[0]] = !0;
    for (let s = 1; s < o.length; s++)
      t[o[s]] = !0;
  }
  let i = se(e) + se(t) + "*$";
  return [new RegExp("^" + i), new RegExp(i)];
}
function We(n) {
  let e = n.map((o) => typeof o == "string" ? { label: o } : o), [t, i] = e.every((o) => /^\w+$/.test(o.label)) ? [/\w*$/, /\w+$/] : Ne(e);
  return (o) => {
    let s = o.matchBefore(i);
    return s || o.explicit ? { from: s ? s.from : o.pos, options: e, validFor: t } : null;
  };
}
function Bt(n, e) {
  return (t) => {
    for (let i = V(t.state).resolveInner(t.pos, -1); i; i = i.parent) {
      if (n.indexOf(i.name) > -1)
        return null;
      if (i.type.isTop)
        break;
    }
    return e(t);
  };
}
class le {
  constructor(e, t, i, o) {
    this.completion = e, this.source = t, this.match = i, this.score = o;
  }
}
function I(n) {
  return n.selection.main.from;
}
function we(n, e) {
  var t;
  let { source: i } = n, o = e && i[0] != "^", s = i[i.length - 1] != "$";
  return !o && !s ? n : new RegExp(`${o ? "^" : ""}(?:${i})${s ? "$" : ""}`, (t = n.flags) !== null && t !== void 0 ? t : n.ignoreCase ? "i" : "");
}
const Ce = /* @__PURE__ */ Be.define();
function Ve(n, e, t, i) {
  let { main: o } = n.selection, s = t - o.from, l = i - o.from;
  return Object.assign(Object.assign({}, n.changeByRange((r) => r != o && t != i && n.sliceDoc(r.from + s, r.from + l) != n.sliceDoc(t, i) ? { range: r } : {
    changes: { from: r.from + s, to: i == o.from ? r.to : r.from + l, insert: e },
    range: x.cursor(r.from + s + e.length)
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const re = /* @__PURE__ */ new WeakMap();
function He(n) {
  if (!Array.isArray(n))
    return n;
  let e = re.get(n);
  return e || re.set(n, e = We(n)), e;
}
const _ = /* @__PURE__ */ O.define(), M = /* @__PURE__ */ O.define();
class qe {
  constructor(e) {
    this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let t = 0; t < e.length; ) {
      let i = C(e, t), o = S(i);
      this.chars.push(i);
      let s = e.slice(t, t + o), l = s.toUpperCase();
      this.folded.push(C(l == s ? s.toLowerCase() : l, 0)), t += o;
    }
    this.astral = e.length != this.chars.length;
  }
  ret(e, t) {
    return this.score = e, this.matched = t, !0;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(e) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e.length < this.pattern.length)
      return !1;
    let { chars: t, folded: i, any: o, precise: s, byWord: l } = this;
    if (t.length == 1) {
      let d = C(e, 0), P = S(d), v = P == e.length ? 0 : -100;
      if (d != t[0])
        if (d == i[0])
          v += -200;
        else
          return !1;
      return this.ret(v, [0, P]);
    }
    let r = e.indexOf(this.pattern);
    if (r == 0)
      return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let a = t.length, c = 0;
    if (r < 0) {
      for (let d = 0, P = Math.min(e.length, 200); d < P && c < a; ) {
        let v = C(e, d);
        (v == t[c] || v == i[c]) && (o[c++] = d), d += S(v);
      }
      if (c < a)
        return !1;
    }
    let f = 0, h = 0, p = !1, u = 0, w = -1, T = -1, q = /[a-z]/.test(e), L = !0;
    for (let d = 0, P = Math.min(e.length, 200), v = 0; d < P && h < a; ) {
      let g = C(e, d);
      r < 0 && (f < a && g == t[f] && (s[f++] = d), u < a && (g == t[u] || g == i[u] ? (u == 0 && (w = d), T = d + 1, u++) : u = 0));
      let $, z = g < 255 ? g >= 48 && g <= 57 || g >= 97 && g <= 122 ? 2 : g >= 65 && g <= 90 ? 1 : 0 : ($ = ge(g)) != $.toLowerCase() ? 1 : $ != $.toUpperCase() ? 2 : 0;
      (!d || z == 1 && q || v == 0 && z != 0) && (t[h] == g || i[h] == g && (p = !0) ? l[h++] = d : l.length && (L = !1)), v = z, d += S(g);
    }
    return h == a && l[0] == 0 && L ? this.result(-100 + (p ? -200 : 0), l, e) : u == a && w == 0 ? this.ret(-200 - e.length + (T == e.length ? 0 : -100), [0, T]) : r > -1 ? this.ret(-700 - e.length, [r, r + this.pattern.length]) : u == a ? this.ret(-200 + -700 - e.length, [w, T]) : h == a ? this.result(-100 + (p ? -200 : 0) + -700 + (L ? 0 : -1100), l, e) : t.length == 2 ? !1 : this.result((o[0] ? -700 : 0) + -200 + -1100, o, e);
  }
  result(e, t, i) {
    let o = [], s = 0;
    for (let l of t) {
      let r = l + (this.astral ? S(C(i, l)) : 1);
      s && o[s - 1] == l ? o[s - 1] = r : (o[s++] = l, o[s++] = r);
    }
    return this.ret(e - i.length, o);
  }
}
const m = /* @__PURE__ */ me.define({
  combine(n) {
    return De(n, {
      activateOnTyping: !0,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: ze,
      compareCompletions: (e, t) => e.label.localeCompare(t.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e, t) => e && t,
      closeOnBlur: (e, t) => e && t,
      icons: (e, t) => e && t,
      tooltipClass: (e, t) => (i) => ae(e(i), t(i)),
      optionClass: (e, t) => (i) => ae(e(i), t(i)),
      addToOptions: (e, t) => e.concat(t)
    });
  }
});
function ae(n, e) {
  return n ? e ? n + " " + e : n : e;
}
function ze(n, e, t, i, o, s) {
  let l = n.textDirection == ke.RTL, r = l, a = !1, c = "top", f, h, p = e.left - o.left, u = o.right - e.right, w = i.right - i.left, T = i.bottom - i.top;
  if (r && p < Math.min(w, u) ? r = !1 : !r && u < Math.min(w, p) && (r = !0), w <= (r ? p : u))
    f = Math.max(o.top, Math.min(t.top, o.bottom - T)) - e.top, h = Math.min(400, r ? p : u);
  else {
    a = !0, h = Math.min(
      400,
      (l ? e.right : o.right - e.left) - 30
      /* Info.Margin */
    );
    let d = o.bottom - e.bottom;
    d >= T || d > e.top ? f = t.bottom - e.top : (c = "bottom", f = e.bottom - t.top);
  }
  let q = (e.bottom - e.top) / s.offsetHeight, L = (e.right - e.left) / s.offsetWidth;
  return {
    style: `${c}: ${f / q}px; max-width: ${h / L}px`,
    class: "cm-completionInfo-" + (a ? l ? "left-narrow" : "right-narrow" : r ? "left" : "right")
  };
}
function Ke(n) {
  let e = n.addToOptions.slice();
  return n.icons && e.push({
    render(t) {
      let i = document.createElement("div");
      return i.classList.add("cm-completionIcon"), t.type && i.classList.add(...t.type.split(/\s+/g).map((o) => "cm-completionIcon-" + o)), i.setAttribute("aria-hidden", "true"), i;
    },
    position: 20
  }), e.push({
    render(t, i, o) {
      let s = document.createElement("span");
      s.className = "cm-completionLabel";
      let l = t.displayLabel || t.label, r = 0;
      for (let a = 0; a < o.length; ) {
        let c = o[a++], f = o[a++];
        c > r && s.appendChild(document.createTextNode(l.slice(r, c)));
        let h = s.appendChild(document.createElement("span"));
        h.appendChild(document.createTextNode(l.slice(c, f))), h.className = "cm-completionMatchedText", r = f;
      }
      return r < l.length && s.appendChild(document.createTextNode(l.slice(r))), s;
    },
    position: 50
  }, {
    render(t) {
      if (!t.detail)
        return null;
      let i = document.createElement("span");
      return i.className = "cm-completionDetail", i.textContent = t.detail, i;
    },
    position: 80
  }), e.sort((t, i) => t.position - i.position).map((t) => t.render);
}
function K(n, e, t) {
  if (n <= t)
    return { from: 0, to: n };
  if (e < 0 && (e = 0), e <= n >> 1) {
    let o = Math.floor(e / t);
    return { from: o * t, to: (o + 1) * t };
  }
  let i = Math.floor((n - e) / t);
  return { from: n - (i + 1) * t, to: n - i * t };
}
class Qe {
  constructor(e, t, i) {
    this.view = e, this.stateField = t, this.applyCompletion = i, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (a) => this.placeInfo(a),
      key: this
    }, this.space = null, this.currentClass = "";
    let o = e.state.field(t), { options: s, selected: l } = o.open, r = e.state.facet(m);
    this.optionContent = Ke(r), this.optionClass = r.optionClass, this.tooltipClass = r.tooltipClass, this.range = K(s.length, l, r.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (a) => {
      let { options: c } = e.state.field(t).open;
      for (let f = a.target, h; f && f != this.dom; f = f.parentNode)
        if (f.nodeName == "LI" && (h = /-(\d+)$/.exec(f.id)) && +h[1] < c.length) {
          this.applyCompletion(e, c[+h[1]]), a.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (a) => {
      let c = e.state.field(this.stateField, !1);
      c && c.tooltip && e.state.facet(m).closeOnBlur && a.relatedTarget != e.contentDOM && e.dispatch({ effects: M.of(null) });
    }), this.showOptions(s, o.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, t) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, t, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e) {
    var t;
    let i = e.state.field(this.stateField), o = e.startState.field(this.stateField);
    if (this.updateTooltipClass(e.state), i != o) {
      let { options: s, selected: l, disabled: r } = i.open;
      (!o.open || o.open.options != s) && (this.range = K(s.length, l, e.state.facet(m).maxRenderedOptions), this.showOptions(s, i.id)), this.updateSel(), r != ((t = o.open) === null || t === void 0 ? void 0 : t.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!r);
    }
  }
  updateTooltipClass(e) {
    let t = this.tooltipClass(e);
    if (t != this.currentClass) {
      for (let i of this.currentClass.split(" "))
        i && this.dom.classList.remove(i);
      for (let i of t.split(" "))
        i && this.dom.classList.add(i);
      this.currentClass = t;
    }
  }
  positioned(e) {
    this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e = this.view.state.field(this.stateField), t = e.open;
    if ((t.selected > -1 && t.selected < this.range.from || t.selected >= this.range.to) && (this.range = K(t.options.length, t.selected, this.view.state.facet(m).maxRenderedOptions), this.showOptions(t.options, e.id)), this.updateSelectedOption(t.selected)) {
      this.destroyInfo();
      let { completion: i } = t.options[t.selected], { info: o } = i;
      if (!o)
        return;
      let s = typeof o == "string" ? document.createTextNode(o) : o(i);
      if (!s)
        return;
      "then" in s ? s.then((l) => {
        l && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(l, i);
      }).catch((l) => G(this.view.state, l, "completion info")) : this.addInfoPane(s, i);
    }
  }
  addInfoPane(e, t) {
    this.destroyInfo();
    let i = this.info = document.createElement("div");
    if (i.className = "cm-tooltip cm-completionInfo", e.nodeType != null)
      i.appendChild(e), this.infoDestroy = null;
    else {
      let { dom: o, destroy: s } = e;
      i.appendChild(o), this.infoDestroy = s || null;
    }
    this.dom.appendChild(i), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e) {
    let t = null;
    for (let i = this.list.firstChild, o = this.range.from; i; i = i.nextSibling, o++)
      i.nodeName != "LI" || !i.id ? o-- : o == e ? i.hasAttribute("aria-selected") || (i.setAttribute("aria-selected", "true"), t = i) : i.hasAttribute("aria-selected") && i.removeAttribute("aria-selected");
    return t && Ye(this.list, t), t;
  }
  measureInfo() {
    let e = this.dom.querySelector("[aria-selected]");
    if (!e || !this.info)
      return null;
    let t = this.dom.getBoundingClientRect(), i = this.info.getBoundingClientRect(), o = e.getBoundingClientRect(), s = this.space;
    if (!s) {
      let l = this.dom.ownerDocument.defaultView || window;
      s = { left: 0, top: 0, right: l.innerWidth, bottom: l.innerHeight };
    }
    return o.top > Math.min(s.bottom, t.bottom) - 10 || o.bottom < Math.max(s.top, t.top) + 10 ? null : this.view.state.facet(m).positionInfo(this.view, t, o, i, s, this.dom);
  }
  placeInfo(e) {
    this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e, t, i) {
    const o = document.createElement("ul");
    o.id = t, o.setAttribute("role", "listbox"), o.setAttribute("aria-expanded", "true"), o.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let s = null;
    for (let l = i.from; l < i.to; l++) {
      let { completion: r, match: a } = e[l], { section: c } = r;
      if (c) {
        let p = typeof c == "string" ? c : c.name;
        if (p != s && (l > i.from || i.from == 0))
          if (s = p, typeof c != "string" && c.header)
            o.appendChild(c.header(c));
          else {
            let u = o.appendChild(document.createElement("completion-section"));
            u.textContent = p;
          }
      }
      const f = o.appendChild(document.createElement("li"));
      f.id = t + "-" + l, f.setAttribute("role", "option");
      let h = this.optionClass(r);
      h && (f.className = h);
      for (let p of this.optionContent) {
        let u = p(r, this.view.state, a);
        u && f.appendChild(u);
      }
    }
    return i.from && o.classList.add("cm-completionListIncompleteTop"), i.to < e.length && o.classList.add("cm-completionListIncompleteBottom"), o;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function Xe(n, e) {
  return (t) => new Qe(t, n, e);
}
function Ye(n, e) {
  let t = n.getBoundingClientRect(), i = e.getBoundingClientRect(), o = t.height / n.offsetHeight;
  i.top < t.top ? n.scrollTop -= (t.top - i.top) / o : i.bottom > t.bottom && (n.scrollTop += (i.bottom - t.bottom) / o);
}
function ce(n) {
  return (n.boost || 0) * 100 + (n.apply ? 10 : 0) + (n.info ? 5 : 0) + (n.type ? 1 : 0);
}
function Ge(n, e) {
  let t = [], i = null, o = (a) => {
    t.push(a);
    let { section: c } = a.completion;
    if (c) {
      i || (i = []);
      let f = typeof c == "string" ? c : c.name;
      i.some((h) => h.name == f) || i.push(typeof c == "string" ? { name: f } : c);
    }
  };
  for (let a of n)
    if (a.hasResult()) {
      let c = a.result.getMatch;
      if (a.result.filter === !1)
        for (let f of a.result.options)
          o(new le(f, a.source, c ? c(f) : [], 1e9 - t.length));
      else {
        let f = new qe(e.sliceDoc(a.from, a.to));
        for (let h of a.result.options)
          if (f.match(h.label)) {
            let p = h.displayLabel ? c ? c(h, f.matched) : [] : f.matched;
            o(new le(h, a.source, p, f.score + (h.boost || 0)));
          }
      }
    }
  if (i) {
    let a = /* @__PURE__ */ Object.create(null), c = 0, f = (h, p) => {
      var u, w;
      return ((u = h.rank) !== null && u !== void 0 ? u : 1e9) - ((w = p.rank) !== null && w !== void 0 ? w : 1e9) || (h.name < p.name ? -1 : 1);
    };
    for (let h of i.sort(f))
      c -= 1e5, a[h.name] = c;
    for (let h of t) {
      let { section: p } = h.completion;
      p && (h.score += a[typeof p == "string" ? p : p.name]);
    }
  }
  let s = [], l = null, r = e.facet(m).compareCompletions;
  for (let a of t.sort((c, f) => f.score - c.score || r(c.completion, f.completion))) {
    let c = a.completion;
    !l || l.label != c.label || l.detail != c.detail || l.type != null && c.type != null && l.type != c.type || l.apply != c.apply || l.boost != c.boost ? s.push(a) : ce(a.completion) > ce(l) && (s[s.length - 1] = a), l = a.completion;
  }
  return s;
}
class A {
  constructor(e, t, i, o, s, l) {
    this.options = e, this.attrs = t, this.tooltip = i, this.timestamp = o, this.selected = s, this.disabled = l;
  }
  setSelected(e, t) {
    return e == this.selected || e >= this.options.length ? this : new A(this.options, fe(t, e), this.tooltip, this.timestamp, e, this.disabled);
  }
  static build(e, t, i, o, s) {
    let l = Ge(e, t);
    if (!l.length)
      return o && e.some(
        (a) => a.state == 1
        /* State.Pending */
      ) ? new A(o.options, o.attrs, o.tooltip, o.timestamp, o.selected, !0) : null;
    let r = t.facet(m).selectOnOpen ? 0 : -1;
    if (o && o.selected != r && o.selected != -1) {
      let a = o.options[o.selected].completion;
      for (let c = 0; c < l.length; c++)
        if (l[c].completion == a) {
          r = c;
          break;
        }
    }
    return new A(l, fe(i, r), {
      pos: e.reduce((a, c) => c.hasResult() ? Math.min(a, c.from) : a, 1e8),
      create: tt,
      above: s.aboveCursor
    }, o ? o.timestamp : Date.now(), r, !1);
  }
  map(e) {
    return new A(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: e.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
}
class N {
  constructor(e, t, i) {
    this.active = e, this.id = t, this.open = i;
  }
  static start() {
    return new N(_e, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e) {
    let { state: t } = e, i = t.facet(m), s = (i.override || t.languageDataAt("autocomplete", I(t)).map(He)).map((r) => (this.active.find((c) => c.source == r) || new b(
      r,
      this.active.some(
        (c) => c.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(e, i));
    s.length == this.active.length && s.every((r, a) => r == this.active[a]) && (s = this.active);
    let l = this.open;
    l && e.docChanged && (l = l.map(e.changes)), e.selection || s.some((r) => r.hasResult() && e.changes.touchesRange(r.from, r.to)) || !Je(s, this.active) ? l = A.build(s, t, this.id, l, i) : l && l.disabled && !s.some(
      (r) => r.state == 1
      /* State.Pending */
    ) && (l = null), !l && s.every(
      (r) => r.state != 1
      /* State.Pending */
    ) && s.some((r) => r.hasResult()) && (s = s.map((r) => r.hasResult() ? new b(
      r.source,
      0
      /* State.Inactive */
    ) : r));
    for (let r of e.effects)
      r.is(Se) && (l = l && l.setSelected(r.value, this.id));
    return s == this.active && l == this.open ? this : new N(s, this.id, l);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : Ze;
  }
}
function Je(n, e) {
  if (n == e)
    return !0;
  for (let t = 0, i = 0; ; ) {
    for (; t < n.length && !n[t].hasResult; )
      t++;
    for (; i < e.length && !e[i].hasResult; )
      i++;
    let o = t == n.length, s = i == e.length;
    if (o || s)
      return o == s;
    if (n[t++].result != e[i++].result)
      return !1;
  }
}
const Ze = {
  "aria-autocomplete": "list"
};
function fe(n, e) {
  let t = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": n
  };
  return e > -1 && (t["aria-activedescendant"] = n + "-" + e), t;
}
const _e = [];
function J(n) {
  return n.isUserEvent("input.type") ? "input" : n.isUserEvent("delete.backward") ? "delete" : null;
}
class b {
  constructor(e, t, i = -1) {
    this.source = e, this.state = t, this.explicitPos = i;
  }
  hasResult() {
    return !1;
  }
  update(e, t) {
    let i = J(e), o = this;
    i ? o = o.handleUserEvent(e, i, t) : e.docChanged ? o = o.handleChange(e) : e.selection && o.state != 0 && (o = new b(
      o.source,
      0
      /* State.Inactive */
    ));
    for (let s of e.effects)
      if (s.is(_))
        o = new b(o.source, 1, s.value ? I(e.state) : -1);
      else if (s.is(M))
        o = new b(
          o.source,
          0
          /* State.Inactive */
        );
      else if (s.is(ve))
        for (let l of s.value)
          l.source == o.source && (o = l);
    return o;
  }
  handleUserEvent(e, t, i) {
    return t == "delete" || !i.activateOnTyping ? this.map(e.changes) : new b(
      this.source,
      1
      /* State.Pending */
    );
  }
  handleChange(e) {
    return e.changes.touchesRange(I(e.startState)) ? new b(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty || this.explicitPos < 0 ? this : new b(this.source, this.state, e.mapPos(this.explicitPos));
  }
}
class R extends b {
  constructor(e, t, i, o, s) {
    super(e, 2, t), this.result = i, this.from = o, this.to = s;
  }
  hasResult() {
    return !0;
  }
  handleUserEvent(e, t, i) {
    var o;
    let s = e.changes.mapPos(this.from), l = e.changes.mapPos(this.to, 1), r = I(e.state);
    if ((this.explicitPos < 0 ? r <= s : r < this.from) || r > l || t == "delete" && I(e.startState) == this.from)
      return new b(
        this.source,
        t == "input" && i.activateOnTyping ? 1 : 0
        /* State.Inactive */
      );
    let a = this.explicitPos < 0 ? -1 : e.changes.mapPos(this.explicitPos), c;
    return et(this.result.validFor, e.state, s, l) ? new R(this.source, a, this.result, s, l) : this.result.update && (c = this.result.update(this.result, s, l, new xe(e.state, r, a >= 0))) ? new R(this.source, a, c, c.from, (o = c.to) !== null && o !== void 0 ? o : I(e.state)) : new b(this.source, 1, a);
  }
  handleChange(e) {
    return e.changes.touchesRange(this.from, this.to) ? new b(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty ? this : new R(this.source, this.explicitPos < 0 ? -1 : e.mapPos(this.explicitPos), this.result, e.mapPos(this.from), e.mapPos(this.to, 1));
  }
}
function et(n, e, t, i) {
  if (!n)
    return !1;
  let o = e.sliceDoc(t, i);
  return typeof n == "function" ? n(o, t, i, e) : we(n, !0).test(o);
}
const ve = /* @__PURE__ */ O.define({
  map(n, e) {
    return n.map((t) => t.map(e));
  }
}), Se = /* @__PURE__ */ O.define(), y = /* @__PURE__ */ Z.define({
  create() {
    return N.start();
  },
  update(n, e) {
    return n.update(e);
  },
  provide: (n) => [
    Fe.from(n, (e) => e.tooltip),
    F.contentAttributes.from(n, (e) => e.attrs)
  ]
});
function Ie(n, e) {
  const t = e.completion.apply || e.completion.label;
  let i = n.state.field(y).active.find((o) => o.source == e.source);
  return i instanceof R ? (typeof t == "string" ? n.dispatch(Object.assign(Object.assign({}, Ve(n.state, t, i.from, i.to)), { annotations: Ce.of(e.completion) })) : t(n, e.completion, i.from, i.to), !0) : !1;
}
const tt = /* @__PURE__ */ Xe(y, Ie);
function U(n, e = "option") {
  return (t) => {
    let i = t.state.field(y, !1);
    if (!i || !i.open || i.open.disabled || Date.now() - i.open.timestamp < t.state.facet(m).interactionDelay)
      return !1;
    let o = 1, s;
    e == "page" && (s = ye(t, i.open.tooltip)) && (o = Math.max(2, Math.floor(s.dom.offsetHeight / s.dom.querySelector("li").offsetHeight) - 1));
    let { length: l } = i.open.options, r = i.open.selected > -1 ? i.open.selected + o * (n ? 1 : -1) : n ? 0 : l - 1;
    return r < 0 ? r = e == "page" ? 0 : l - 1 : r >= l && (r = e == "page" ? l - 1 : 0), t.dispatch({ effects: Se.of(r) }), !0;
  };
}
const it = (n) => {
  let e = n.state.field(y, !1);
  return n.state.readOnly || !e || !e.open || e.open.selected < 0 || e.open.disabled || Date.now() - e.open.timestamp < n.state.facet(m).interactionDelay ? !1 : Ie(n, e.open.options[e.open.selected]);
}, nt = (n) => n.state.field(y, !1) ? (n.dispatch({ effects: _.of(!0) }), !0) : !1, ot = (n) => {
  let e = n.state.field(y, !1);
  return !e || !e.active.some(
    (t) => t.state != 0
    /* State.Inactive */
  ) ? !1 : (n.dispatch({ effects: M.of(null) }), !0);
};
class st {
  constructor(e, t) {
    this.active = e, this.context = t, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const lt = 50, rt = 1e3, at = /* @__PURE__ */ je.fromClass(class {
  constructor(n) {
    this.view = n, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.composing = 0;
    for (let e of n.state.field(y).active)
      e.state == 1 && this.startQuery(e);
  }
  update(n) {
    let e = n.state.field(y);
    if (!n.selectionSet && !n.docChanged && n.startState.field(y) == e)
      return;
    let t = n.transactions.some((i) => (i.selection || i.docChanged) && !J(i));
    for (let i = 0; i < this.running.length; i++) {
      let o = this.running[i];
      if (t || o.updates.length + n.transactions.length > lt && Date.now() - o.time > rt) {
        for (let s of o.context.abortListeners)
          try {
            s();
          } catch (l) {
            G(this.view.state, l);
          }
        o.context.abortListeners = null, this.running.splice(i--, 1);
      } else
        o.updates.push(...n.transactions);
    }
    if (this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), this.debounceUpdate = e.active.some((i) => i.state == 1 && !this.running.some((o) => o.active.source == i.source)) ? setTimeout(() => this.startUpdate(), 50) : -1, this.composing != 0)
      for (let i of n.transactions)
        J(i) == "input" ? this.composing = 2 : this.composing == 2 && i.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1;
    let { state: n } = this.view, e = n.field(y);
    for (let t of e.active)
      t.state == 1 && !this.running.some((i) => i.active.source == t.source) && this.startQuery(t);
  }
  startQuery(n) {
    let { state: e } = this.view, t = I(e), i = new xe(e, t, n.explicitPos == t), o = new st(n, i);
    this.running.push(o), Promise.resolve(n.source(i)).then((s) => {
      o.context.aborted || (o.done = s || null, this.scheduleAccept());
    }, (s) => {
      this.view.dispatch({ effects: M.of(null) }), G(this.view.state, s);
    });
  }
  scheduleAccept() {
    this.running.every((n) => n.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(m).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var n;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e = [], t = this.view.state.facet(m);
    for (let i = 0; i < this.running.length; i++) {
      let o = this.running[i];
      if (o.done === void 0)
        continue;
      if (this.running.splice(i--, 1), o.done) {
        let l = new R(o.active.source, o.active.explicitPos, o.done, o.done.from, (n = o.done.to) !== null && n !== void 0 ? n : I(o.updates.length ? o.updates[0].startState : this.view.state));
        for (let r of o.updates)
          l = l.update(r, t);
        if (l.hasResult()) {
          e.push(l);
          continue;
        }
      }
      let s = this.view.state.field(y).active.find((l) => l.source == o.active.source);
      if (s && s.state == 1)
        if (o.done == null) {
          let l = new b(
            o.active.source,
            0
            /* State.Inactive */
          );
          for (let r of o.updates)
            l = l.update(r, t);
          l.state != 1 && e.push(l);
        } else
          this.startQuery(s);
    }
    e.length && this.view.dispatch({ effects: ve.of(e) });
  }
}, {
  eventHandlers: {
    blur(n) {
      let e = this.view.state.field(y, !1);
      if (e && e.tooltip && this.view.state.facet(m).closeOnBlur) {
        let t = e.open && ye(this.view, e.open.tooltip);
        (!t || !t.dom.contains(n.relatedTarget)) && this.view.dispatch({ effects: M.of(null) });
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: _.of(!1) }), 20), this.composing = 0;
    }
  }
}), Oe = /* @__PURE__ */ F.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
class ct {
  constructor(e, t, i, o) {
    this.field = e, this.line = t, this.from = i, this.to = o;
  }
}
class ee {
  constructor(e, t, i) {
    this.field = e, this.from = t, this.to = i;
  }
  map(e) {
    let t = e.mapPos(this.from, -1, Y.TrackDel), i = e.mapPos(this.to, 1, Y.TrackDel);
    return t == null || i == null ? null : new ee(this.field, t, i);
  }
}
class te {
  constructor(e, t) {
    this.lines = e, this.fieldPositions = t;
  }
  instantiate(e, t) {
    let i = [], o = [t], s = e.doc.lineAt(t), l = /^\s*/.exec(s.text)[0];
    for (let a of this.lines) {
      if (i.length) {
        let c = l, f = /^\t*/.exec(a)[0].length;
        for (let h = 0; h < f; h++)
          c += e.facet(Ue);
        o.push(t + c.length - f), a = c + a.slice(f);
      }
      i.push(a), t += a.length + 1;
    }
    let r = this.fieldPositions.map((a) => new ee(a.field, o[a.line] + a.from, o[a.line] + a.to));
    return { text: i, ranges: r };
  }
  static parse(e) {
    let t = [], i = [], o = [], s;
    for (let l of e.split(/\r\n?|\n/)) {
      for (; s = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(l); ) {
        let r = s[1] ? +s[1] : null, a = s[2] || s[3] || "", c = -1;
        for (let f = 0; f < t.length; f++)
          (r != null ? t[f].seq == r : a && t[f].name == a) && (c = f);
        if (c < 0) {
          let f = 0;
          for (; f < t.length && (r == null || t[f].seq != null && t[f].seq < r); )
            f++;
          t.splice(f, 0, { seq: r, name: a }), c = f;
          for (let h of o)
            h.field >= c && h.field++;
        }
        o.push(new ct(c, i.length, s.index, s.index + a.length)), l = l.slice(0, s.index) + a + l.slice(s.index + s[0].length);
      }
      for (let r; r = /\\([{}])/.exec(l); ) {
        l = l.slice(0, r.index) + r[1] + l.slice(r.index + r[0].length);
        for (let a of o)
          a.line == i.length && a.from > r.index && (a.from--, a.to--);
      }
      i.push(l);
    }
    return new te(i, o);
  }
}
let ft = /* @__PURE__ */ W.widget({ widget: /* @__PURE__ */ new class extends $e {
  toDOM() {
    let n = document.createElement("span");
    return n.className = "cm-snippetFieldPosition", n;
  }
  ignoreEvent() {
    return !1;
  }
}() }), ht = /* @__PURE__ */ W.mark({ class: "cm-snippetField" });
class D {
  constructor(e, t) {
    this.ranges = e, this.active = t, this.deco = W.set(e.map((i) => (i.from == i.to ? ft : ht).range(i.from, i.to)));
  }
  map(e) {
    let t = [];
    for (let i of this.ranges) {
      let o = i.map(e);
      if (!o)
        return null;
      t.push(o);
    }
    return new D(t, this.active);
  }
  selectionInsideField(e) {
    return e.ranges.every((t) => this.ranges.some((i) => i.field == this.active && i.from <= t.from && i.to >= t.to));
  }
}
const j = /* @__PURE__ */ O.define({
  map(n, e) {
    return n && n.map(e);
  }
}), pt = /* @__PURE__ */ O.define(), B = /* @__PURE__ */ Z.define({
  create() {
    return null;
  },
  update(n, e) {
    for (let t of e.effects) {
      if (t.is(j))
        return t.value;
      if (t.is(pt) && n)
        return new D(n.ranges, t.value);
    }
    return n && e.docChanged && (n = n.map(e.changes)), n && e.selection && !n.selectionInsideField(e.selection) && (n = null), n;
  },
  provide: (n) => F.decorations.from(n, (e) => e ? e.deco : W.none)
});
function ie(n, e) {
  return x.create(n.filter((t) => t.field == e).map((t) => x.range(t.from, t.to)));
}
function ut(n) {
  let e = te.parse(n);
  return (t, i, o, s) => {
    let { text: l, ranges: r } = e.instantiate(t.state, o), a = {
      changes: { from: o, to: s, insert: Me.of(l) },
      scrollIntoView: !0,
      annotations: i ? Ce.of(i) : void 0
    };
    if (r.length && (a.selection = ie(r, 0)), r.length > 1) {
      let c = new D(r, 0), f = a.effects = [j.of(c)];
      t.state.field(B, !1) === void 0 && f.push(O.appendConfig.of([B, yt, xt, Oe]));
    }
    t.dispatch(t.state.update(a));
  };
}
function Te(n) {
  return ({ state: e, dispatch: t }) => {
    let i = e.field(B, !1);
    if (!i || n < 0 && i.active == 0)
      return !1;
    let o = i.active + n, s = n > 0 && !i.ranges.some((l) => l.field == o + n);
    return t(e.update({
      selection: ie(i.ranges, o),
      effects: j.of(s ? null : new D(i.ranges, o)),
      scrollIntoView: !0
    })), !0;
  };
}
const dt = ({ state: n, dispatch: e }) => n.field(B, !1) ? (e(n.update({ effects: j.of(null) })), !0) : !1, mt = /* @__PURE__ */ Te(1), gt = /* @__PURE__ */ Te(-1), bt = [
  { key: "Tab", run: mt, shift: gt },
  { key: "Escape", run: dt }
], he = /* @__PURE__ */ me.define({
  combine(n) {
    return n.length ? n[0] : bt;
  }
}), yt = /* @__PURE__ */ de.highest(/* @__PURE__ */ be.compute([he], (n) => n.facet(he)));
function kt(n, e) {
  return Object.assign(Object.assign({}, e), { apply: ut(n) });
}
const xt = /* @__PURE__ */ F.domEventHandlers({
  mousedown(n, e) {
    let t = e.state.field(B, !1), i;
    if (!t || (i = e.posAtCoords({ x: n.clientX, y: n.clientY })) == null)
      return !1;
    let o = t.ranges.find((s) => s.from <= i && s.to >= i);
    return !o || o.field == t.active ? !1 : (e.dispatch({
      selection: ie(t.ranges, o.field),
      effects: j.of(t.ranges.some((s) => s.field > o.field) ? new D(t.ranges, o.field) : null),
      scrollIntoView: !0
    }), !0);
  }
}), k = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, E = /* @__PURE__ */ O.define({
  map(n, e) {
    let t = e.mapPos(n, -1, Y.TrackAfter);
    return t ?? void 0;
  }
}), ne = /* @__PURE__ */ new class extends Le {
}();
ne.startSide = 1;
ne.endSide = -1;
const Ee = /* @__PURE__ */ Z.define({
  create() {
    return oe.empty;
  },
  update(n, e) {
    if (e.selection) {
      let t = e.state.doc.lineAt(e.selection.main.head).from, i = e.startState.doc.lineAt(e.startState.selection.main.head).from;
      t != e.changes.mapPos(i, -1) && (n = oe.empty);
    }
    n = n.map(e.changes);
    for (let t of e.effects)
      t.is(E) && (n = n.update({ add: [ne.range(t.value, t.value + 1)] }));
    return n;
  }
});
function Ft() {
  return [Ct, Ee];
}
const Q = "()[]{}<>";
function Pe(n) {
  for (let e = 0; e < Q.length; e += 2)
    if (Q.charCodeAt(e) == n)
      return Q.charAt(e + 1);
  return ge(n < 128 ? n : n + 1);
}
function Ae(n, e) {
  return n.languageDataAt("closeBrackets", e)[0] || k;
}
const wt = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), Ct = /* @__PURE__ */ F.inputHandler.of((n, e, t, i) => {
  if ((wt ? n.composing : n.compositionStarted) || n.state.readOnly)
    return !1;
  let o = n.state.selection.main;
  if (i.length > 2 || i.length == 2 && S(C(i, 0)) == 1 || e != o.from || t != o.to)
    return !1;
  let s = St(n.state, i);
  return s ? (n.dispatch(s), !0) : !1;
}), vt = ({ state: n, dispatch: e }) => {
  if (n.readOnly)
    return !1;
  let i = Ae(n, n.selection.main.head).brackets || k.brackets, o = null, s = n.changeByRange((l) => {
    if (l.empty) {
      let r = It(n.doc, l.head);
      for (let a of i)
        if (a == r && H(n.doc, l.head) == Pe(C(a, 0)))
          return {
            changes: { from: l.head - a.length, to: l.head + a.length },
            range: x.cursor(l.head - a.length)
          };
    }
    return { range: o = l };
  });
  return o || e(n.update(s, { scrollIntoView: !0, userEvent: "delete.backward" })), !o;
}, jt = [
  { key: "Backspace", run: vt }
];
function St(n, e) {
  let t = Ae(n, n.selection.main.head), i = t.brackets || k.brackets;
  for (let o of i) {
    let s = Pe(C(o, 0));
    if (e == o)
      return s == o ? Et(n, o, i.indexOf(o + o + o) > -1, t) : Ot(n, o, s, t.before || k.before);
    if (e == s && Re(n, n.selection.main.from))
      return Tt(n, o, s);
  }
  return null;
}
function Re(n, e) {
  let t = !1;
  return n.field(Ee).between(0, n.doc.length, (i) => {
    i == e && (t = !0);
  }), t;
}
function H(n, e) {
  let t = n.sliceString(e, e + 2);
  return t.slice(0, S(C(t, 0)));
}
function It(n, e) {
  let t = n.sliceString(e - 2, e);
  return S(C(t, 0)) == t.length ? t : t.slice(1);
}
function Ot(n, e, t, i) {
  let o = null, s = n.changeByRange((l) => {
    if (!l.empty)
      return {
        changes: [{ insert: e, from: l.from }, { insert: t, from: l.to }],
        effects: E.of(l.to + e.length),
        range: x.range(l.anchor + e.length, l.head + e.length)
      };
    let r = H(n.doc, l.head);
    return !r || /\s/.test(r) || i.indexOf(r) > -1 ? {
      changes: { insert: e + t, from: l.head },
      effects: E.of(l.head + e.length),
      range: x.cursor(l.head + e.length)
    } : { range: o = l };
  });
  return o ? null : n.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function Tt(n, e, t) {
  let i = null, o = n.changeByRange((s) => s.empty && H(n.doc, s.head) == t ? {
    changes: { from: s.head, to: s.head + t.length, insert: t },
    range: x.cursor(s.head + t.length)
  } : i = { range: s });
  return i ? null : n.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function Et(n, e, t, i) {
  let o = i.stringPrefixes || k.stringPrefixes, s = null, l = n.changeByRange((r) => {
    if (!r.empty)
      return {
        changes: [{ insert: e, from: r.from }, { insert: e, from: r.to }],
        effects: E.of(r.to + e.length),
        range: x.range(r.anchor + e.length, r.head + e.length)
      };
    let a = r.head, c = H(n.doc, a), f;
    if (c == e) {
      if (pe(n, a))
        return {
          changes: { insert: e + e, from: a },
          effects: E.of(a + e.length),
          range: x.cursor(a + e.length)
        };
      if (Re(n, a)) {
        let p = t && n.sliceDoc(a, a + e.length * 3) == e + e + e ? e + e + e : e;
        return {
          changes: { from: a, to: a + p.length, insert: p },
          range: x.cursor(a + p.length)
        };
      }
    } else {
      if (t && n.sliceDoc(a - 2 * e.length, a) == e + e && (f = ue(n, a - 2 * e.length, o)) > -1 && pe(n, f))
        return {
          changes: { insert: e + e + e + e, from: a },
          effects: E.of(a + e.length),
          range: x.cursor(a + e.length)
        };
      if (n.charCategorizer(a)(c) != X.Word && ue(n, a, o) > -1 && !Pt(n, a, e, o))
        return {
          changes: { insert: e + e, from: a },
          effects: E.of(a + e.length),
          range: x.cursor(a + e.length)
        };
    }
    return { range: s = r };
  });
  return s ? null : n.update(l, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function pe(n, e) {
  let t = V(n).resolveInner(e + 1);
  return t.parent && t.from == e;
}
function Pt(n, e, t, i) {
  let o = V(n).resolveInner(e, -1), s = i.reduce((l, r) => Math.max(l, r.length), 0);
  for (let l = 0; l < 5; l++) {
    let r = n.sliceDoc(o.from, Math.min(o.to, o.from + t.length + s)), a = r.indexOf(t);
    if (!a || a > -1 && i.indexOf(r.slice(0, a)) > -1) {
      let f = o.firstChild;
      for (; f && f.from == o.from && f.to - f.from > t.length + a; ) {
        if (n.sliceDoc(f.to - t.length, f.to) == t)
          return !1;
        f = f.firstChild;
      }
      return !0;
    }
    let c = o.to == e && o.parent;
    if (!c)
      break;
    o = c;
  }
  return !1;
}
function ue(n, e, t) {
  let i = n.charCategorizer(e);
  if (i(n.sliceDoc(e - 1, e)) != X.Word)
    return e;
  for (let o of t) {
    let s = e - o.length;
    if (n.sliceDoc(s, e) == o && i(n.sliceDoc(s - 1, s)) != X.Word)
      return s;
  }
  return -1;
}
function $t(n = {}) {
  return [
    y,
    m.of(n),
    at,
    Rt,
    Oe
  ];
}
const At = [
  { key: "Ctrl-Space", run: nt },
  { key: "Escape", run: ot },
  { key: "ArrowDown", run: /* @__PURE__ */ U(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ U(!1) },
  { key: "PageDown", run: /* @__PURE__ */ U(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ U(!1, "page") },
  { key: "Enter", run: it }
], Rt = /* @__PURE__ */ de.highest(/* @__PURE__ */ be.computeN([m], (n) => n.facet(m).defaultKeymap ? [At] : []));
export {
  xe as CompletionContext,
  it as acceptCompletion,
  $t as autocompletion,
  dt as clearSnippet,
  Ft as closeBrackets,
  jt as closeBracketsKeymap,
  ot as closeCompletion,
  We as completeFromList,
  At as completionKeymap,
  vt as deleteBracketPair,
  Bt as ifNotIn,
  St as insertBracket,
  Ve as insertCompletionText,
  U as moveCompletionSelection,
  mt as nextSnippetField,
  Ce as pickedCompletion,
  gt as prevSnippetField,
  ut as snippet,
  kt as snippetCompletion,
  he as snippetKeymap,
  nt as startCompletion
};
